import React, { useState } from "react";
import { Modal, ModalBody, Button, Textarea, Input, Select } from "@windmill/react-ui";

const CancelOfflineModal = ({
  isOpen,
  onClose,
  onConfirm,
  cancellationExceed,
  sellingPrice = 0,
}) => {
  const [reason, setReason] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [cancellationType, setCancellationType] = useState("percentage");

  // console.log(expiredCancel)
  const handleConfirm = () => {
    onConfirm(reason, inputValue, cancellationExceed, cancellationType);
    setReason("");
    setInputValue("");
    setCancellationType("percentage");
  };

  const isInputValid = () => {
    const val = parseFloat(inputValue);
    if (isNaN(val)) return false;

    if (cancellationExceed) {
      return val >= 0 && val <= sellingPrice;
    } else {
      if (cancellationType === "percentage") {
        return val > 0 && val <= 100;
      } else {
        return val >= 0 && val <= sellingPrice;
      }
    }
  };

  const handleInputChange = (e) => {
    let val = e.target.value;
    if (val === "") {
      setInputValue("");
      return;
    }

    val = parseFloat(val);
    if (isNaN(val)) return;

    if (cancellationExceed) {
      if (val > sellingPrice) val = sellingPrice;
    } else {
      if (cancellationType === "percentage") {
        if (val > 100) val = 100;
      } else {
        if (val > sellingPrice) val = sellingPrice;
      }
    }

    setInputValue(val.toString());
  };

  const resetState = () => {
    setReason("");
    setInputValue("");
    setCancellationType("percentage");
  };

  return (
    <Modal
      className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
      isOpen={isOpen}
      onClose={() => {
        resetState();
        onClose();
      }}
    >
      <ModalBody className="custom-modal">
        <p className="text-lg font-semibold">
          Are you sure that you want to cancel this booking?
        </p>

        {cancellationExceed && (
          <div className="text-red-500 mt-2 mb-4" role="alert">
            Warning: This booking is being canceled on or after its start date.
          </div>
        )}

        <div className="mt-4">
          <Textarea
            className="focus:shadow-none border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
            placeholder="Enter Cancel Reason (Minimum 10 characters)"
            rows="4"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        {!cancellationExceed && (
          <div className="mt-4">
            <Select
              className="w-full"
              value={cancellationType}
              onChange={(e) => {
                setCancellationType(e.target.value);
                setInputValue("");
              }}
            >
              <option value="percentage">Percentage (%)</option>
              <option value="value">Fixed Value (₹)</option>
            </Select>
          </div>
        )}

        <div className="mt-4">
          <Input
            type="number"
            className="focus:shadow-none border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
            placeholder={
              cancellationExceed
                ? "Enter Refundable Amount"
                : cancellationType === "percentage"
                ? "Enter Cancellation Percentage (1-100)"
                : `Enter Cancellation Value (≤ ₹${sellingPrice})`
            }
            value={inputValue}
            min="0"
            max={
              cancellationExceed
                ? sellingPrice
                : cancellationType === "percentage"
                ? 100
                : sellingPrice
            }
            autoComplete="off"
            step="0.01"
            onChange={handleInputChange}
          />
        </div>

        <div className="flex justify-end mt-4">
          <Button
            layout="outline"
            onClick={() => {
              resetState();
              onClose();
            }}
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          >
            No
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={reason.length < 10 || !isInputValid()}
          >
            Yes
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CancelOfflineModal;
